import { render, staticRenderFns } from "./PerformanceMetricsToolbar.vue?vue&type=template&id=427afd50&scoped=true&"
import script from "./PerformanceMetricsToolbar.vue?vue&type=script&lang=js&"
export * from "./PerformanceMetricsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceMetricsToolbar.vue?vue&type=style&index=0&id=427afd50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427afd50",
  null
  
)

export default component.exports